import { SpeedControl } from '@/components/shared/speed-control'
import { Switch } from '@/components/ui/switch'

type AutoPauseControlProps = {
  autoPauseEnabled: boolean
  autoPauseMultiplier: number
  isPausedByAuto: boolean
  autoPauseProgress: number
  autoPauseTotal: number
  onAutoPauseEnabledChange: (enabled: boolean) => void
  onAutoPauseMultiplierChange: (multiplier: number) => void
}

const SPEED_PRESETS = [1.0, 1.5, 2.0, 3.0, 4.0, 5.0]

export const AutoPauseControl = ({
  autoPauseEnabled,
  autoPauseMultiplier,
  onAutoPauseEnabledChange,
  onAutoPauseMultiplierChange,
}: AutoPauseControlProps) => {
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium">1文ごとに自動一時停止</span>
        <Switch checked={autoPauseEnabled} onCheckedChange={onAutoPauseEnabledChange} />
      </div>

      {autoPauseEnabled && (
        <div className="mb-2">
          <SpeedControl
            presetSpeeds={SPEED_PRESETS}
            min={1.0}
            max={5.0}
            step={0.1}
            playbackSpeed={autoPauseMultiplier}
            onChangeSpeed={onAutoPauseMultiplierChange}
          />
        </div>
      )}
    </div>
  )
}
